import { render, staticRenderFns } from "./CompanyDetails.vue?vue&type=template&id=75b3153a"
import script from "./CompanyDetails.vue?vue&type=script&lang=js"
export * from "./CompanyDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports